































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Action, State, Getter } from "vuex-class";
import moment from "moment";
import LeadProduct from "./LeadProduct.vue";
import LeadPaymentDetails from "./PaymentDetails.vue";
import LeadRequestEsig from "./LeadRequestEsig.vue";
import LeadNotes from "./LeadNotes.vue";
import LeadNotesCustomerService from "./LeadNotesCustomerService.vue";
import PersonalDetails from "./PersonalDetails.vue";
import Verification from "./Verification.vue";
import LeadCalls from "./LeadCalls.vue";
import ScriptPrompt from "@/components/ScriptPrompt/Prompt.vue";
import SendTextAndEmail from "@/components/Messaging/SendTextAndEmail.vue";
import DoctorNomination from "@/components/Lead/DoctorNomination.vue";
import { collections } from "@/configs/firebase";
import { User, CallMode, Features } from "@/types";
import logger from "@/configs/logger";
import { Routes } from "@/router/routes";
import { objectify } from "../../helpers";
import { checkFeatureAccess } from "@/helpers/permissions";
import getCallConfigs from "@/helpers/getCallConfig";

@Component({
  components: {
    LeadProduct,
    LeadRequestEsig,
    PersonalDetails,
    Verification,
    LeadPaymentDetails,
    LeadCalls,
    LeadNotes,
    LeadNotesCustomerService,
    ScriptPrompt,
    SendTextAndEmail,
    DoctorNomination
  }
})
export default class LeadPanel extends Vue {
  @Prop() leadId!: any;
  // @Prop() loadLeads!: Function; to do - reload after user update
  @Getter("callMode") callMode!: CallMode;
  @State("user") user!: User;
  @Action("getLeadCallHistory") getLeadCallHistory!: Function;

  unsubscribe!: Function;
  lead: any = null;
  leadDoesNotExist: boolean = false;
  detailPanel = -1; // zero based index for an open panel
  totalChildren = 1;
  callHistory: any[] = [];
  loadingCallHistory = false;

  @Watch("leadId")
  onLeadIdUpdate(val: string, prev: string) {
    if (val !== prev) {
      this.getLead();
    }
  }

  mounted() {
    this.getLead();
  }

  get hasLead() {
    if (!this.lead) return false;

    let hasValue = false;
    let blackListKey = ["created_ts", "twilio_inbound_call_request_data"];
    for (const key of Object.keys(this.lead)) {
      if (this.lead[key] && !blackListKey.includes(key)) {
        hasValue = true;
      }
    }
    return hasValue;
  }

  get isVerificationAgent() {
    return this.user.roles.includes("verification");
  }

  get isCustomerService() {
    const roles = this.user.roles;
    return roles.includes("customer_service") || roles.includes("admin");
  }

  get isAdmin() {
    return this.user.roles.includes("admin");
  }

  get isT3Fronter() {
    if (this.user.groups) {
      return !!this.user.groups.find((item: string) =>
        item.startsWith("fronter_t3")
      );
    }
    return false;
  }

  get scriptPageType() {
    return getCallConfigs(this.user.groups).script || "closer_qualified";
  }

  get tabs(): string[] {
    const closerOrder = [
      "INFO",
      "PRODUCTS",
      "PAYMENTS",
      "REQUEST_ESIG",
      "NOTES",
      "HISTORY",
      "MESSAGING",
      "DOCTOR"
    ];
    const verOrder = [
      "ESIG_VERIFICATION",
      "PRODUCTS",
      "INFO",
      "PAYMENTS",
      "NOTES",
      "HISTORY",
      "MESSAGING",
      "DOCTOR"
    ];
    const fronterT3Order = ["INFO"];

    if (this.callMode !== "inCall" || this.$route.name !== Routes.DashBoard) {
      closerOrder.push("SCRIPT");
      verOrder.push("SCRIPT");
      fronterT3Order.push("SCRIPT");
    }

    if (this.$route.name === Routes.Verification) {
      if (this.isAdmin) {
        verOrder.splice(1, 0, "REQUEST_ESIG");
      }
      return verOrder;
    } else {
      if (this.isAdmin) {
        closerOrder.splice(1, 0, "ESIG_VERIFICATION");
      }
      if (this.isCustomerService) {
        closerOrder.splice(5, 0, "CUSTOMER_SERVICE_NOTES");
      }
      if (this.isT3Fronter) {
        return fronterT3Order;
      }
      return closerOrder;
    }
  }

  beforeDestroy() {
    this.unsubscribe && this.unsubscribe();
  }

  getLead(leadId = this.leadId) {
    if (!leadId) {
      logger("error", "no lead id in lead panel");
      return;
    }
    if (this.unsubscribe) this.unsubscribe();
    this.unsubscribe = collections.lead.doc(leadId).onSnapshot(snapshot => {
      if (!snapshot.exists) this.leadDoesNotExist = true;
      this.lead = { ...snapshot.data(), id: snapshot.id };
    });
  }
}
